import { Box, Grid, IconButton, Menu, MenuItem, Tooltip, Typography } from '@mui/material'
import { icons } from '../../constants/images'
import { BoxCard, BoxTitle } from './boxDocStyle';
import InputCheckbox from '../input/inputCheckbox';
import React from 'react';
import { swalActive, swalError, swalSuccess } from '../notification/swal';
import FolderApi from '../../api/folder/folder.api';
import FileApi from '../../api/file/file.api';
import saveAs from 'file-saver';
const options = [
    'ดูเอกสาร',
    'ดาวน์โหลด',
    'ทำซ้ำ',
    'การเข้าถึง',
];
type Props = {
    icon: any
    title: string
    onClick?: () => void
    dropDown?: boolean
    checkbox?: boolean
    style?: any
    id: number
    type?: string
    file?: any
    loadData?: any
    handleClickOpenCreate?: any
    detail?: any
    setInputFolder?: any
    inputFolder?: any
    setLevelFiles?: any
    levelfiles?: any
    stepView?: number
    layer?: number
}
const ITEM_HEIGHT = 48;
export default function BoxDoc(props: Props) {
    const { icon, title, onClick, dropDown, checkbox, style, id, type, file, loadData, handleClickOpenCreate, detail, inputFolder, setInputFolder, setLevelFiles, levelfiles, stepView, layer } = props
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const deleteFolder = async () => {

        swalActive(
            `ยืนยันที่จะลบหรือไม่?`,
            null, (res: any) => {
                if (res) {
                    FolderApi.patchFolderDelete(id)
                        .then(async (res) => {
                            swalSuccess('ลบสำเร็จ')
                            setInputFolder({ ...inputFolder, stepView: stepView === inputFolder?.stepView ? inputFolder?.stepView : stepView })
                            loadData()
                        })
                        .catch((error) => {
                            swalError(error.response.data.description || error.response.data.message);

                        })
                }
            })
    }
    const deleteFile = async () => {
        swalActive(
            `ยืนยันที่จะลบหรือไม่?`,
            null, (res: any) => {
                if (res) {
                    FileApi.deleteFile(id)
                        .then(async (res) => {
                            swalSuccess('ลบสำเร็จ')
                            loadData()
                        })
                        .catch((error) => {
                            console.log(error);
                            swalError(error.response.data.description || error.response.data.message);
                        })
                }
            })
    }
    const download = async () => {
        if (type === 'file') {
            const res = await FileApi.getFileDownload(file?.idFile)
            const blob = new Blob([res.data], { type: file?.fileType });
            const url = window.URL.createObjectURL(blob)
            saveAs(url, file?.fileName)
        } else {
            const res = await FolderApi.getFolderDownload(id)
            const blob = new Blob([res.data], { type: 'application/zip' },);
            const url = window.URL.createObjectURL(blob)
            saveAs(url, 'Folder')
        }
    }
    return (
        <Tooltip title={title} placement="bottom">

            <Grid item lg={2} sx={{ cursor: 'pointer', position: 'relative', }} >
                <Box sx={{ display: 'flex', flexDirection: "column", alignItems: "center", justifyContent: "center", padding: '10px', ...style }}>
                    <BoxCard onClick={onClick}>
                        {icon}
                    </BoxCard>
                    <BoxTitle>
                        <Typography style={{
                            whiteSpace: 'nowrap',
                            display: "-webkit-box",
                            WebkitBoxOrient: "vertical",
                            WebkitLineClamp: "1",
                            overflow: "hidden",
                        }}>{title}</Typography>
                        {!dropDown && <>
                            <IconButton
                                aria-label="more"
                                id="long-button"
                                aria-controls={open ? 'long-menu' : undefined}
                                aria-expanded={open ? 'true' : undefined}
                                aria-haspopup="true"
                                onClick={handleClick}
                            >
                                <icons.dotMenuV />
                            </IconButton>
                            <Menu
                                id="long-menu"
                                MenuListProps={{
                                    'aria-labelledby': 'long-button',
                                }}
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                PaperProps={{
                                    style: {
                                        maxHeight: ITEM_HEIGHT * 4.5,
                                        width: '20ch',
                                    },
                                }}
                            >
                                <MenuItem
                                    onClick={() => {
                                        handleClose()
                                        download()
                                    }}>
                                    ดาวน์โหลด
                                </MenuItem>
                                {(detail?.idFile || detail?.level === 5) &&
                                    <MenuItem
                                        onClick={() => {
                                            handleClose()
                                            deleteFile()
                                        }}>
                                        ลบไฟล์
                                    </MenuItem>}
                                {
                                    detail?.permissionLevel !== 1 && type !== 'file' &&
                                    <MenuItem
                                        onClick={() => {
                                            handleClose()
                                            deleteFolder()
                                        }}>
                                        ลบ
                                    </MenuItem>}
                                {
                                    detail?.permissionLevel !== 1 && type !== 'file' && <MenuItem
                                        onClick={() => {
                                            setInputFolder({
                                                ...detail,
                                                stepView: stepView,
                                                layer: layer
                                            })
                                            handleClickOpenCreate()
                                            handleClose()
                                        }}>
                                        แก้ไข
                                    </MenuItem>}
                            </Menu>
                        </>}
                    </BoxTitle>
                    {
                        !checkbox &&
                        <div style={{ position: "absolute", left: '36px', top: "20px" }}>
                            <InputCheckbox checked={detail?.check || false} onChange={(e) => {
                                setLevelFiles([
                                    ...levelfiles?.filter((x: any) => !x?.idFile),
                                    ...levelfiles?.filter((x: any) => x?.idFile)?.map((x: any) => {
                                        x.check = x?.idFile === id ? e.target.checked : x?.check || false
                                        return x
                                    })
                                ])
                            }} />
                        </div>
                    }</Box>
            </Grid>
        </Tooltip>
    )
}
